// Cookie / analytics consent (GDPR). localStorage is the single source of truth.
// PostHog is configured with opt_out_capturing_by_default in index.html, so
// nothing is captured until the visitor explicitly accepts.
export const CONSENT_KEY = "ph-consent"; // "granted" | "denied" | null (undecided)

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    return null;
  }
};

// Push the stored decision to PostHog. The injected stub queues these calls
// until the library finishes loading, so it is safe to call early.
export const applyConsent = (value) => {
  const ph = typeof window !== "undefined" ? window.posthog : null;
  if (!ph || typeof ph.opt_in_capturing !== "function") return;
  if (value === "granted") ph.opt_in_capturing();
  else ph.opt_out_capturing();
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch (e) {
    /* ignore */
  }
  applyConsent(value);
};

export const hasAnalyticsConsent = () => getConsent() === "granted";
